module.exports = __webpack_public_path__ + "static/media/app-example.f01dff69.png";